import { NgClass } from '@angular/common';
import { Component, inject, computed } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { computeClasses } from '../../../core/utils/class';
import { AuthState } from '../../../features/auth/services/auth.state';
import { Footer } from '../../components/footer/footer';
import { Header } from '../../components/header/header';
import { UserHeader } from '../../components/user-header/user-header';
import { MainLayoutState } from '../../services/main-layout.state';
import { SidebarV2 } from '../../components/sidebar-v2/sidebar-v2';

@Component({
  selector: 'main-layout',
  imports: [
    Header,
    Footer,
    RouterOutlet,
    NgClass,
    UserHeader,
    SidebarV2,
  ],
  templateUrl: './main-layout.html',
  styleUrl: './main-layout.scss',
})
export class MainLayout {
  private layoutState = inject(MainLayoutState);
  public authState = inject(AuthState);

  readonly config = this.layoutState.config;

  readonly classes = computed(() => {
    const config = this.config();
    const isLoggedIn = this.authState.isLoggedIn();
    return computeClasses('main-layout', {
      'with-padding': config.withPadding,
      'with-user-header': config.userHeader.show,
      'is-logged-in': isLoggedIn,
    });
  });
}
